const DateCreatedIcon = () => (
    <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.75 5.5C10.75 5.08579 10.4142 4.75 10 4.75C9.58579 4.75 9.25 5.08579 9.25 5.5V7.07926C7.81067 7.19451 6.86577 7.47737 6.17157 8.17157C5.47737 8.86577 5.19451 9.81067 5.07926 11.25H24.9207C24.8055 9.81067 24.5226 8.86577 23.8284 8.17157C23.1342 7.47737 22.1893 7.19451 20.75 7.07926V5.5C20.75 5.08579 20.4142 4.75 20 4.75C19.5858 4.75 19.25 5.08579 19.25 5.5V7.0129C18.5847 7 17.839 7 17 7H13C12.161 7 11.4153 7 10.75 7.0129V5.5Z"
            fill="#AFB1BA"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 15C5 14.161 5 13.4153 5.0129 12.75H24.9871C25 13.4153 25 14.161 25 15V17C25 20.7712 25 22.6569 23.8284 23.8284C22.6569 25 20.7712 25 17 25H13C9.22876 25 7.34315 25 6.17157 23.8284C5 22.6569 5 20.7712 5 17V15ZM20 17C20.5523 17 21 16.5523 21 16C21 15.4477 20.5523 15 20 15C19.4477 15 19 15.4477 19 16C19 16.5523 19.4477 17 20 17ZM20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20C19 20.5523 19.4477 21 20 21ZM16 16C16 16.5523 15.5523 17 15 17C14.4477 17 14 16.5523 14 16C14 15.4477 14.4477 15 15 15C15.5523 15 16 15.4477 16 16ZM16 20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19C15.5523 19 16 19.4477 16 20ZM10 17C10.5523 17 11 16.5523 11 16C11 15.4477 10.5523 15 10 15C9.44772 15 9 15.4477 9 16C9 16.5523 9.44772 17 10 17ZM10 21C10.5523 21 11 20.5523 11 20C11 19.4477 10.5523 19 10 19C9.44772 19 9 19.4477 9 20C9 20.5523 9.44772 21 10 21Z"
            fill="#AFB1BA"
        />
    </svg>
);

export default DateCreatedIcon;
